<template>
    <div>
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
          <i
            class="material-icons"
            id="menu-toggle"
            @click="isSidebar = !isSidebar"
            >view_headline</i
          >
          <app-navbar></app-navbar>
  
          <div class="container-fluid mt-5">
            <!-- Title and Breadcrumb Starts -->
            <div class="row">
              <div class="col-sm-12 print-media">
                <vs-breadcrumb
                  align="left"
                  :items="[
                    { title: 'You are here : ' },
                    {
                      title: 'Reports',
                      url: '/#/dashboard/CountryRepresentative/allReports',
                      active: false
                    },
                    {
                      title: 'Analysis Report',
                      url: '/#/dashboard/CountryRepresentative/analysisReport',
                      active: true,
                    },
                  ]"
                ></vs-breadcrumb>
              </div>
            </div>
            <AnalysisReport />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  import AnalysisReport from "../../commonPages/AnalysisReport"
  
  export default {
      data: () => ({
          isSidebar: false,
  
      }),
  
      components: {
          "app-navbar": Navbar,
          "app-sidebar": Sidebar,
          AnalysisReport
      },
  
  };
  </script>
  
  <style scoped>
  #menu-toggle {
      display: none;
  }
  @media print {
    .print-media {
      display: none;
    }
  }
  
  @media (max-width: 768px) {
      #menu-toggle {
          display: block;
      }
  }
  </style>
  